export const countryCodes: Record<string, number> = {
  ad: 0,
  ae: 1,
  af: 2,
  ag: 3,
  ai: 4,
  al: 5,
  am: 6,
  ao: 7,
  aq: 8,
  ar: 9,
  as: 10,
  at: 11,
  au: 12,
  aw: 13,
  ax: 14,
  az: 15,
  ba: 16,
  bb: 17,
  bd: 18,
  be: 19,
  bf: 20,
  bg: 21,
  bh: 22,
  bi: 23,
  bj: 24,
  bl: 25,
  bm: 26,
  bn: 27,
  bo: 28,
  bq: 29,
  br: 30,
  bs: 31,
  bt: 32,
  bv: 33,
  bw: 34,
  by: 35,
  bz: 36,
  ca: 37,
  cc: 38,
  cd: 39,
  cf: 40,
  cg: 41,
  ch: 42,
  ci: 43,
  ck: 44,
  cl: 45,
  cm: 46,
  cn: 47,
  co: 48,
  cr: 49,
  cu: 50,
  cv: 51,
  cw: 52,
  cx: 53,
  cy: 54,
  cz: 55,
  de: 56,
  dj: 57,
  dk: 58,
  dm: 59,
  do: 60,
  dz: 61,
  ec: 62,
  ee: 63,
  eg: 64,
  eh: 65,
  er: 66,
  'es-ct': 67,
  'es-ga': 68,
  es: 69,
  et: 70,
  eu: 71,
  fi: 72,
  fj: 73,
  fk: 74,
  fm: 75,
  fo: 76,
  fr: 77,
  ga: 78,
  'gb-eng': 79,
  'gb-nir': 80,
  'gb-sct': 81,
  'gb-wls': 82,
  gb: 83,
  gd: 84,
  ge: 85,
  gf: 86,
  gg: 87,
  gh: 88,
  gi: 89,
  gl: 90,
  gm: 91,
  gn: 92,
  gp: 93,
  gq: 94,
  gr: 95,
  gs: 96,
  gt: 97,
  gu: 98,
  gw: 99,
  gy: 100,
  hk: 101,
  hm: 102,
  hn: 103,
  hr: 104,
  ht: 105,
  hu: 106,
  id: 107,
  ie: 108,
  il: 109,
  im: 110,
  in: 111,
  io: 112,
  iq: 113,
  ir: 114,
  is: 115,
  it: 116,
  je: 117,
  jm: 118,
  jo: 119,
  jp: 120,
  ke: 121,
  kg: 122,
  kh: 123,
  ki: 124,
  km: 125,
  kn: 126,
  kp: 127,
  kr: 128,
  kw: 129,
  ky: 130,
  kz: 131,
  la: 132,
  lb: 133,
  lc: 134,
  li: 135,
  lk: 136,
  lr: 137,
  ls: 138,
  lt: 139,
  lu: 140,
  lv: 141,
  ly: 142,
  ma: 143,
  mc: 144,
  md: 145,
  me: 146,
  mf: 147,
  mg: 148,
  mh: 149,
  mk: 150,
  ml: 151,
  mm: 152,
  mn: 153,
  mo: 154,
  mp: 155,
  mq: 156,
  mr: 157,
  ms: 158,
  mt: 159,
  mu: 160,
  mv: 161,
  mw: 162,
  mx: 163,
  my: 164,
  mz: 165,
  na: 166,
  nc: 167,
  ne: 168,
  nf: 169,
  ng: 170,
  ni: 171,
  nl: 172,
  no: 173,
  np: 174,
  nr: 175,
  nu: 176,
  nz: 177,
  om: 178,
  pa: 179,
  pe: 180,
  pf: 181,
  pg: 182,
  ph: 183,
  pk: 184,
  pl: 185,
  pm: 186,
  pn: 187,
  pr: 188,
  ps: 189,
  pt: 190,
  pw: 191,
  py: 192,
  qa: 193,
  re: 194,
  ro: 195,
  rs: 196,
  ru: 197,
  rw: 198,
  sa: 199,
  sb: 200,
  sc: 201,
  sd: 202,
  se: 203,
  sg: 204,
  sh: 205,
  si: 206,
  sj: 207,
  sk: 208,
  sl: 209,
  sm: 210,
  sn: 211,
  so: 212,
  sr: 213,
  ss: 214,
  st: 215,
  sv: 216,
  sx: 217,
  sy: 218,
  sz: 219,
  tc: 220,
  td: 221,
  tf: 222,
  tg: 223,
  th: 224,
  tj: 225,
  tk: 226,
  tl: 227,
  tm: 228,
  tn: 229,
  to: 230,
  tr: 231,
  tt: 232,
  tv: 233,
  tw: 234,
  tz: 235,
  ua: 236,
  ug: 237,
  um: 238,
  un: 239,
  us: 240,
  uy: 241,
  uz: 242,
  va: 243,
  vc: 244,
  ve: 245,
  vg: 246,
  vi: 247,
  vn: 248,
  vu: 249,
  wf: 250,
  ws: 251,
  xk: 252,
  ye: 253,
  yt: 254,
  za: 255,
  zm: 256,
  zw: 257,
};
